import React from 'react'
import { Router } from '@reach/router'
import netlifyIdentity from 'netlify-identity-widget'
import { ThemeProvider } from 'emotion-theming'

import GrandCentral from './pages/GrandCentral'
import Home from './pages/Home'
import Shortener from './pages/Shortener'


const App = () => {
  netlifyIdentity.init()
  window.netlifyIdentity = netlifyIdentity

  return (
    <ThemeProvider theme={{}}>
      <Router>
        <Home path="/" />
        <Shortener path="chiquito" />
        <GrandCentral default />
      </Router>
    </ThemeProvider>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js